module.exports = __webpack_public_path__ + "static/media/redac.2c6c9edc.png";